import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { authLogin, authMe, setToken, clearToken } from "@/lib/store";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = loading, false = anon
  useEffect(() => {
    if (!localStorage.getItem("iphix_token")) { setUser(false); return; }
    authMe().then(setUser).catch(() => { clearToken(); setUser(false); });
  }, []);
  const login = async (email, password) => {
    const data = await authLogin(email, password);
    setToken(data.token); setUser(data.user); return data.user;
  };
  const logout = () => { clearToken(); setUser(false); };
  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center bg-[#090B0E] text-zinc-400">Caricamento…</div>;
  if (!user || !["admin", "manager", "staff"].includes(user.role)) return <Navigate to="/login" replace />;
  return children;
};
